import irrigation_sched from "../../images/homepage/Irrigation_Schedule.png";
import "../../css/common.module.css";

export default function Irrigation() {
  return (
    <div className="container mt-6">
      <div className="row block-row">
        <div class="col justify-content-start pt-2">
           <h5 class="text-start ps-6 card-header fw-semibold block-title">
           Irrigation Schedule
          </h5>
          <p className="fs-5"> </p>
	      <span class="float-start"> <img className="img-fluid" src={irrigation_sched} 
	       style={{
	            paddingLeft: "0px",
	            paddingRight: "0px",
	            height: "400px",
	          }}
	       ></img></span>
	    </div>
      </div>
    </div>
  );
}
